import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import "@/App.css";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { HomePage } from "@/pages/HomePage";
import { ResidentialPage } from "@/pages/ResidentialPage";
import { PropertyManagersPage } from "@/pages/PropertyManagersPage";
import { EndOfLeasePage } from "@/pages/EndOfLeasePage";
import { CommercialPage } from "@/pages/CommercialPage";
import { OurWorkPage } from "@/pages/OurWorkPage";
import { ServiceAreasPage } from "@/pages/ServiceAreasPage";
import { AboutPage } from "@/pages/AboutPage";
import { ContactPage } from "@/pages/ContactPage";
import { PrivacyPage } from "@/pages/PrivacyPage";
import { SuburbPage } from "@/pages/SuburbPage";
import { SUBURB_PAGES } from "@/content";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

const useLenis = () => {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09 });
    let raf;
    const loop = (t) => { lenis.raf(t); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); };
  }, []);
};

function App() {
  useLenis();
  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="min-h-screen pb-14 md:pb-0">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/residential-cleaning" element={<ResidentialPage />} />
            <Route path="/property-managers" element={<PropertyManagersPage />} />
            <Route path="/end-of-lease-cleaning" element={<EndOfLeasePage />} />
            <Route path="/commercial-cleaning" element={<CommercialPage />} />
            <Route path="/our-work" element={<OurWorkPage />} />
            <Route path="/service-areas" element={<ServiceAreasPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/privacy-policy" element={<PrivacyPage />} />
            {SUBURB_PAGES.map((s) => (
              <Route key={s.slug} path={`/${s.slug}`} element={<SuburbPage slug={s.slug} />} />
            ))}
            <Route path="*" element={<HomePage />} />
          </Routes>
        </main>
        <Footer />
      </div>
      <Toaster position="top-center" richColors />
    </BrowserRouter>
  );
}

export default App;
